import React from 'react'
import LineChartPanel from '../../../components/Charts/LineChartPanel'
import FilterPanel from '../components/FilterPanel'

const WinLoseReportCompare = () => {
  return (
    <div className='p-2'>
         <div className='flex justify-between border-b border-b-gray-300 pb-2 mb-2'>
              <h6 className="font-semibold">Win Lose Report Compare</h6>
              <FilterPanel/>
          </div>
          <div className="w-full h-[250px]">
          <LineChartPanel />
          </div>
         
    </div>
  )
}

export default WinLoseReportCompare